// Tiny bridge so non-React modules (e.g. the axios interceptor in
// services/api) can dispatch to the Redux store WITHOUT importing the store
// directly.
//
// Importing the store from services/api creates a circular dependency
// (store -> slices -> services/api -> store), which crashes at load time with
// "Cannot access '__WEBPACK_DEFAULT_EXPORT__' before initialization".
//
// This file imports nothing, so it can be safely imported from anywhere. The
// store registers itself here once at app startup (see index.js), and other
// modules read it back synchronously at runtime.
let registeredStore = null;

export const registerStore = (store) => {
  registeredStore = store;
};

export const getStore = () => registeredStore;
